import { __assign } from "tslib";
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { DynamicPortal, Text, Tooltip } from '@keen.io/ui-core';
import { TOOLTIP_MOTION } from '../../../constants';
export var CopyCellTooltip = function (_a) {
    var tooltipState = _a.tooltipState, tooltipSettings = _a.tooltipSettings;
    return (React.createElement(DynamicPortal, null,
        React.createElement(AnimatePresence, null, tooltipState.visible && (React.createElement(motion.div, __assign({}, TOOLTIP_MOTION, { initial: { opacity: 0, x: tooltipState.x, y: tooltipState.y }, animate: {
                x: tooltipState.x,
                y: tooltipState.y,
                opacity: 1,
            }, style: {
                position: 'absolute',
                pointerEvents: 'none',
                zIndex: 1,
            } }),
            React.createElement(Tooltip, { mode: tooltipSettings.mode, hasArrow: false },
                React.createElement(Text, __assign({}, tooltipSettings.labels.typography), "Cell copied!")))))));
};
